module.exports = {"1":"Muito mau","2":"Mau","3":"Aceitável","4":"Bom","5":"Excelente","1.5":"Muito mau","2.5":"Mau","3.5":"Aceitável","4.5":"Excelente"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/pt-PT/star-ratings.json
// module id = 1332
// module chunks = 0